import React from 'react'
import { UseFormReturn, useFormState } from 'react-hook-form'
import { hasFieldErrors } from './FieldErrorGate.helpers'

type Props = {
  form: UseFormReturn<any>
  fields?: string[]
  children: (fieldsHaveErrors: boolean) => React.ReactElement
}

/** Subscribes to react-hook-form validation state for a step's `fields`
 *  and hands the resulting error flag to `children`. Rendered only when a
 *  real form is wired up, so the common no-form path pays no hook cost. */
export const FieldErrorGate = ({ form, fields, children }: Props) => {
  const { errors } = useFormState({ control: form.control, name: fields })
  return children(hasFieldErrors(fields, errors))
}
